module.exports = "<p>\r\n\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/footer/footer.component.html
// module id = ../../../../../src/app/_components/footer/footer.component.html
// module chunks = 1